import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { FCC } from "@/types/common";
import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import { TRsoForm } from "@/features/rso/types/rsoForm";
import { useFormContext, useWatch } from "react-hook-form";
import { useMemo } from "react";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { formatRSOId } from "@/utils/number";
import { Tooltip } from "@/components/elements/Tooltip";
import { IconErrorOutline } from "@/assets/icons";
import { black, text } from "@/theme/colors";

export const RsoBasicInfoSection: FCC = () => {
  const { control } = useFormContext<TRsoForm>();
  const idValue = useWatch({ control, name: "id" });

  const formattedId = useMemo(() => {
    return formatRSOId(idValue);
  }, [idValue]);

  return (
    <InnerBox title={<CompanyFormTitle text="基本情報" />} showDivider={false}>
      <Grid container rowSpacing={2} columnSpacing={3} mt={-2}>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography variant="cap12Light">組織ID</Typography>
            <Tooltip title="" content="お客様の固有識別番号(ID)です。ログイン時やお問い合わせ時に使用されることがございます。">
              <Box component="span" sx={{ display: "inline-flex", verticalAlign: "middle", lineHeight: 0 }}>
                <IconErrorOutline width={15} height={15} color={black[80]} />
              </Box>
            </Tooltip>
          </Stack>
          <Typography
            variant="body14Semi"
            color={text.primary}
            sx={{
              fontFamily: "inherit",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {formattedId}
          </Typography>
          <Divider sx={{ marginTop: "8px" }} />
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="name" required>
            <Input placeholder="入力してください" />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="licenseNumber">
            <Input placeholder="入力してください" />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
